module.exports = __webpack_public_path__ + "static/media/plus-filled.641a6594.svg";